import { useQuery } from '@tanstack/react-query';
import { EmployerService } from '@/infra/services/employer';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';

interface GetListEmployerParams {
	organization_id: string;
	company_id: string;
	name?: string;
	offset?: number;
	limit?: number;
}

const Service = EmployerService.getInstance();

export const useGetListEmployer = (params: GetListEmployerParams) => {
	const isEnabled = validateUuid([params.company_id, params.organization_id]);
	return useQuery({
		queryKey: [QUERY_KEYS.GET_LIST_EMPLOYER, params],
		queryFn: async () => Service.index(params),
		enabled: isEnabled
	});
};
